// FullScreen Layout (eg: login, register pages)
export default function LayoutFullscreen(props: any) {
  return <>{props.children}</>;
}
